import confetti from "canvas-confetti";

/**
 * Quick celebratory burst — fires once from each bottom corner toward
 * the center of the screen. Respects the user's reduced-motion
 * preference. Radix dialogs portal at high stacking contexts, so we use
 * a very large z-index to ensure the canvas paints on top.
 */
export function fireCelebrationConfetti() {
  const defaults = {
    particleCount: 120,
    spread: 55,
    startVelocity: 90,
    ticks: 200,
    gravity: 0.9,
    scalar: 1.1,
    zIndex: 9999,
    disableForReducedMotion: true,
  };
  confetti({
    ...defaults,
    angle: 60,
    origin: { x: 0, y: 1 },
  });
  confetti({
    ...defaults,
    angle: 120,
    origin: { x: 1, y: 1 },
  });
}
